import React from "react";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Logo from "shared/Logo/Logo";
import { Disclosure } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import { NavItemType } from "./NavigationItem";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { useData } from "data/data-provider";
import { useHiddenSectionLink } from "utils/useHiddenSectionLink";
import { withTrackBookingItem } from "utils/trackBooking";

export interface NavMobileProps {
  onClickClose?: () => void;
}

const NavMobile: React.FC<NavMobileProps> = ({ onClickClose }) => {
  const { companyDetails } = useData();
  const hiddenLink = useHiddenSectionLink();

  const _renderMenuChild = (item: NavItemType) => {
    return (
      <ul className="nav-mobile-sub-menu list-none pl-6 pb-1 text-base">
        {item.children?.map((i, index) => (
          <Disclosure key={index} as="li">
            <NavLink
              end
              to={{
                pathname: i.href || undefined,
              }}
              className={({ isActive }) =>
                `flex px-4 text-text-color text-sm font-medium rounded-md hover:bg-neutral-100 mt-0.5 ${
                  isActive ? "text-secondary" : ""
                }`
              }
            >
              <span
                className={`py-2.5 pr-3 ${!i.children ? "block w-full" : ""}`}
              >
                {i.name}
              </span>
              {i.children && (
                <span
                  className="flex-1 flex"
                  onClick={(e) => e.preventDefault()}
                >
                  <Disclosure.Button
                    as="span"
                    className="py-2.5 flex justify-end flex-1"
                  >
                    <ChevronDownIcon
                      className="ml-2 h-4 w-4 text-text-color"
                      aria-hidden="true"
                    />
                  </Disclosure.Button>
                </span>
              )}
            </NavLink>
            {i.children && (
              <Disclosure.Panel>{_renderMenuChild(i)}</Disclosure.Panel>
            )}
          </Disclosure>
        ))}
      </ul>
    );
  };

  const _renderItem = (item: any, index: number) => {
    return (
      <Disclosure key={item.id} as="li" className="text-text-color ">
        {!item.children && (
          <NavLink
            end
            className={({ isActive }) =>
              `flex w-full px-4 font-medium uppercase tracking-wide text-sm hover:bg-neutral-100 rounded-md ${
                isActive ? "text-secondary" : ""
              }`
            }
            to={item?.url}
          >
            <span
              className={`py-2.5 pr-3 ${!item.children ? "block w-full" : ""}`}
            >
              {item.name}
            </span>
          </NavLink>
        )}

        {item.children && (
          <div
            className={`flex w-full px-4 font-medium uppercase tracking-wide text-sm hover:bg-neutral-100 rounded-md ${"text-secondary"}`}
          >
            {item.children && (
              <span className="flex-1 flex" onClick={(e) => e.preventDefault()}>
                <Disclosure.Button
                  as="span"
                  className="py-2.5 flex items-center justify-between flex-1 "
                >
                  <span
                    className={`py-2.5 pr-3 ${
                      !item.children ? "block w-full" : ""
                    }`}
                  >
                    {item.name}
                  </span>
                  <ChevronDownIcon
                    className="ml-2 h-4 w-4 text-text-color"
                    aria-hidden="true"
                  />
                </Disclosure.Button>
              </span>
            )}
          </div>
        )}

        {item.children && (
          <Disclosure.Panel>{_renderMenuChild(item)}</Disclosure.Panel>
        )}
      </Disclosure>
    );
  };

  return (
    <div className="nc-NavMobile overflow-y-auto w-full h-screen py-2 transition transform shadow-lg ring-1 bg-bg-color divide-y-2 divide-secondary-50">
      <div className="py-6 px-5">
        <Logo />
        {/* <div className="flex flex-col mt-5 text-text-color text-sm">
          <div className="flex justify-between items-center mt-4">
            <SocialsList itemClass="w-9 h-9 flex items-center justify-center rounded-full bg-neutral-100 text-xl " />
          </div>
        </div> */}
        <span className="absolute right-2 top-2 p-1">
          <ButtonClose onClick={onClickClose} />
        </span>
      </div>
      <ul className="ml-0 flex list-none flex-col py-6 px-2 space-y-1">
        {withTrackBookingItem(companyDetails?.navigation_menu_items, companyDetails?.navigation_menu_cleared)
          ?.filter((item: any) => !hiddenLink(item?.url))
          .map(_renderItem)}
      </ul>
      {/* Book Now lives here too: the bar drops it while the search bar is up. */}
      <div className="px-5 py-6">
        <NavLink
          to="/vehicles"
          onClick={onClickClose}
          className="nc-NavMobile-cta flex w-full items-center justify-center rounded-full bg-button-color [.design-a_&]:bg-primary-6000 [.design-a_&]:text-on-primary px-5 py-3 text-sm font-semibold text-on-button"
        >
          Book Now
        </NavLink>
      </div>
    </div>
  );
};

export default NavMobile;
